module.exports = __webpack_public_path__ + "6fc809a2fd9928da1bc7a7e94da4b27e.svg";